import L from 'leaflet';
import { MAP_DEFAULT_ZOOM } from '../map/MapConstants';

export default class MapPin extends L.Marker
{
	constructor(id, latlng, texts = null, lang = 'ja', options = {})
	{
		super(latlng, options);

		this.id = id;

		this._iconsize = 20;

		this._texts = texts;
		this._lang = lang;

		this._zoomLevel = MAP_DEFAULT_ZOOM;
		this._tooltipMinZoom = options.tooltipMinZoom;

		this.onClick = options.onClick || null;

		this.initVars(options);
		this.setIcon(this.createIcon(options));

		if (texts)
		{
			const tooltipOptions = this.getTooltipOptions(options);
			this.bindTooltip(this._texts[lang], tooltipOptions);
		}
	}

	getTooltipOptions(options)
	{
		if (!this._texts)
		{
			return null;
		}

		const icon_w = 15;
		const icon_h = 20;

		let tooltipDirection = 'right';
		let tooltipOffset = L.point(0, 0);

		if (options.tooltipDirection)
		{
			tooltipDirection = options.tooltipDirection;
		}

		const tx = icon_w * .5;
		const ty1 = icon_h * .5;
		const ty2 = icon_h;

		switch (tooltipDirection)
		{
			case 'left':
				tooltipOffset = L.point(-tx, -ty1);
				break;
			case 'right':
				tooltipOffset = L.point(tx, -ty1);
				break;
			case 'top':
				tooltipOffset = L.point(0, -ty2);
				break;
			case 'bottom':
				tooltipOffset = L.point(0, 0);
				break;
		}

		// Tooltip options
		const tooltipOptions =
		{
			className: ['map-pin', this._tooltipClassName].join(' '),
			direction: tooltipDirection,
			offset: tooltipOffset,
			permanent: true
		};

		return tooltipOptions;
	}

	initVars(options = {})
	{
	}

	createIcon(options = {})
	{
		return L.divIcon(
			{
				className: ['map-pin', this._markerClassName].join(' '),
				html: this.makeHTML(options),
			});
	}

	makeHTML(options = {})
	{
		return '<div class="pin-inner">...</div>';
	}

	updateTip()
	{
		if (!this._texts) return;

		this.setTooltipContent(this._texts[this._lang]);
	}

	onAdd(map)
	{
		super.onAdd(map);

		this.updateDataAttribute();

		this._attachClickListeners();
	}

	updateDataAttribute()
	{
		if (!this._texts) return;

		this.updateTooltipMinZoom();
	}

	updateTooltipMinZoom()
	{
		if (!this._texts || this._tooltipMinZoom === undefined)
		{
			return;
		}

		setTimeout(() =>
		{
			const markerElement = this.getElement();
			if (markerElement)
			{
				const tooltipId = markerElement.getAttribute('aria-describedby');
				const tooltipElement = document.getElementById(tooltipId);
				if (tooltipElement)
				{
					tooltipElement.setAttribute('data-min-zoom', this._tooltipMinZoom);
				}
			}
		}
		);
	}

	_attachClickListeners()
	{
		// Marker click
		this.on('click', () =>
		{
			if (this.onClick) this.onClick();
		});

		// Tooltip click
		setTimeout(() =>
		{
			const tooltip = this.getTooltip();
			if (tooltip && tooltip._container)
			{
				tooltip._container.addEventListener('click', () =>
				{
					if (this.onClick)
					{
						this.onClick();
					}
				});
			}
		}, 0);
	}

	handleUpdateZoom()
	{
	}

	highlight()
	{
		const element = this.getElement();
		if (element)
		{
			if (this.hlTimeoutID)
			{
				clearTimeout(this.hlTimeoutID);
			}
			element.classList.add('highlight');
			this.hlTimeoutID = setTimeout(() =>
			{
				element.classList.remove('highlight');
				this.hlTimeoutID = null;
			}, 1800);
		}
	}

	// Getter and setter for lang
	get lang()
	{
		return this._lang;
	}

	set lang(newLang)
	{
		if (this._texts && this._texts[newLang])
		{
			this._lang = newLang;
			this.updateTip();
		}
	}

	get zoomLevel()
	{
		return this._zoomLevel;
	}

	set zoomLevel(value)
	{
		this._zoomLevel = value;
		this.handleUpdateZoom();
	}
}
